<template>
  <v-container fluid class="container">
    <Breadcrumbs :items="breadcrumbs" />

    <v-toolbar flat>
      <span v-if="loader" class="caption grey--text text--darken-1">
        Generating Excel export... {{ progressPercent }}%
      </span>
      <v-spacer />
      <v-btn color="primary" :loading="loader" @click="excelDownloadClick">
        <v-icon left>mdi-file-excel</v-icon>
        Export to Excel
      </v-btn>
    </v-toolbar>

    <Snackbar :text="notificationText" :type="notificationType" />

    <v-overlay :value="loader" :z-index="1000">
      <div class="export-progress">
        <v-progress-circular indeterminate size="64" />
        <div class="export-progress__text">
          Generating Excel export... {{ progressPercent }}%
        </div>
      </div>
    </v-overlay>
  </v-container>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import Snackbar from '@/components/Snackbar';
import api from '@/api/lbt-api';

export default {
  name: 'ExistingBusinessFullAnalytics',
  components: { Breadcrumbs, Snackbar },
  data() {
    return {
      notificationText: '',
      notificationType: null,
      loader: false,
      progressPercent: 0,
      progressTimer: null,
      breadcrumbs: [
        { translationKey: 'breadcrumbs_plannings', route: '/plannings', disabled: false },
        { translationKey: 'existing_business_full_analytics', disabled: true },
      ],
    };
  },
  methods: {
    async excelDownloadClick() {
      this.loader = true;
      this.progressPercent = 0;
      this.startProgressPolling();
      try {
        const response = await api.downloadExistingBusinessFullAnalytics(
          this.$route.params.planningId,
        );
        this.progressPercent = 100;
        const objectUrl = window.URL.createObjectURL(response.blob);
        const anchor = document.createElement('a');
        anchor.href = objectUrl;
        anchor.download = response.fileName
          || `ExistingBusinessFullAnalytics${this.$route.params.planningId}.xlsx`;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        window.URL.revokeObjectURL(objectUrl);
      } catch (e) {
        this.notificationText = e.message || 'Failed to download report';
        this.notificationType = 'error';
        setTimeout(() => { this.notificationText = null; }, 3000);
      } finally {
        this.stopProgressPolling();
        this.loader = false;
      }
    },
    startProgressPolling() {
      this.stopProgressPolling();
      this.progressTimer = window.setInterval(async () => {
        try {
          // Export itself is the source of truth; progress polling is best-effort.
          const progress = await api.getExistingBusinessFullAnalyticsProgress(
            this.$route.params.planningId,
          );
          this.progressPercent = Math.max(
            this.progressPercent,
            Number(progress.percent) || 0,
          );
        } catch (e) {
          if (!e || e.message) {
            this.progressPercent = this.progressPercent || 0;
          }
        }
      }, 1000);
    },
    stopProgressPolling() {
      if (this.progressTimer) {
        window.clearInterval(this.progressTimer);
        this.progressTimer = null;
      }
    },
  },
  beforeDestroy() {
    this.stopProgressPolling();
  },
};
</script>

<style scoped>
.export-progress {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.export-progress__text {
  font-size: 14px;
  margin-top: 16px;
}
</style>
